import React from 'react';
import { PieChart, Pie, Legend, Tooltip, Cell } from 'recharts';
import { CustomTooltip } from "../ChartUtils";


const RADIAN = Math.PI / 180;

// Custom label with extra spacing after tick line
const CustomLabel = ({ percent, value, cx, cy, midAngle, outerRadius }) => {
  if (percent < 0.03) return null;

  const labelRadius = outerRadius + 30; // 30px away from pie center
  const x = cx + labelRadius * Math.cos(-midAngle * RADIAN);
  const y = cy + labelRadius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#616161"
      fontSize={12}
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      pointerEvents="none"
      style={{ userSelect: "none" }}
    >
      {value}
    </text>
  );
};

// Custom tick line (#616161)
const CustomLabelLine = ({ cx, cy, midAngle, outerRadius, percent }) => {
  if (percent < 0.03) return null;

  const startRadius = outerRadius + 2;
  const endRadius = outerRadius + 20;

  const startX = cx + startRadius * Math.cos(-midAngle * RADIAN);
  const startY = cy + startRadius * Math.sin(-midAngle * RADIAN);

  const endX = cx + endRadius * Math.cos(-midAngle * RADIAN);
  const endY = cy + endRadius * Math.sin(-midAngle * RADIAN);

  return (
    <line
      x1={startX}
      y1={startY}
      x2={endX}
      y2={endY}
      stroke="#616161"
      strokeWidth={1}
    />
  );
};

const AribaPieChart = ({data, colorArray}) => (

<PieChart width={500} height={350} className='ariba-piechart' margin={{ top: 20, right: 80, bottom: 20, left: 80 }}>
        <Pie
            data={data}
            cx={150}
            cy={150}
            outerRadius={130}
            fill="#8884d8"
            minAngle={5}
            dataKey="value"
            labelLine={CustomLabelLine}
            label={CustomLabel}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colorArray && colorArray?.length > 0 ? colorArray[index % colorArray?.length] : []} />
            ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
);

export default AribaPieChart;
